import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getTransporterStats } from '../../api/transporteurs';
import { GradientText } from '../PasserCommande/PasserCommande.styles';
import LayoutTransporter from '../../Components/LayoutTransporter/LayoutTransporter';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

function TransporterStats() {
    const { _id } = useSelector((state) => state.auth.user);
    const token = useSelector((state) => state.auth.token);
    const [chargementEnCours, setChargementEnCours] = useState(false);
    const [caMensuel, setCaMensuel] = useState([]);
    const [stats, setStats] = useState([]);
    const { t } = useTranslation();
    const handleFilterChange = async () => {
        setChargementEnCours(true);
        try {

            const response = await getTransporterStats(_id, token);
            setCaMensuel(response.caMensuel);
            setStats(response.stats);
        } catch (error) {
            console.error('Erreur lors de la récupération des statistiques:', error);
        } finally {
            setChargementEnCours(false);
        }
    };


    useEffect(() => {
        handleFilterChange();
    }, [_id]);

    const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


    useEffect(() => {
        const checkIfMobile = () => {
            setSmallScreen(window.innerWidth < 768);
        };
        window.addEventListener('resize', checkIfMobile);

        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
    const barData = {
        options: {
            chart: {
                id: 'monthly-revenue',
                type: 'bar',
                height: 350,
            },
            xaxis: {
                categories: caMensuel.map(item => `${item.month}/${item.year}`),

            },
            yaxis: {
                title: {
                    text: t("monthly_revenue"),
                },
            },
            title: {
                text: t("monthly_expenses"),
                align: 'center',
            },
            tooltip: {
                y: {
                    formatter: (value) => `${value} €`,
                },
            },
            plotOptions: isSmallScreen ? {
                bar: {
                    dataLabels: {
                        position: 'center',
                        orientation: 'vertical',

                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        }
                    },
                }
            } : {}
        },
        series: [
            {
                name: t("monthly_revenue"),
                data: caMensuel.map(item => parseFloat(item.totalPrix.toFixed(3))),
            },
        ],
    };

    const pieSeries = [
        stats[0]?.globalStats[0]?.totalDemarrerCount || 0,
        stats[0]?.globalStats[0]?.totalNonDemarrerCount || 0,
        stats[0]?.globalStats[0]?.totalAnnulerCount || 0,
        stats[0]?.globalStats[0]?.totalTerminerCount || 0
    ];
    const pieOptions = {
        chart: {
            type: 'pie'
        },
        labels: [t("in_progress"), t("not_Started"), t("cancelled"), t("completed")],
        colors: ['#36A2EB', '#FFCE56', '#F44336', '#60a656'],
        legend: {
            position: 'bottom'
        },
        title: {
            text: t("order_distribution_by_status"),
            align: 'center',
            style: {
                fontSize: '16px',
                fontWeight: 'bold'
            }
        }
    };
    const stackedBarData = {
        series: [
            {
                name: t("started"),
                data: stats[0]?.groupedStats?.map(cmd => cmd?.demarrerCount) || [0],
                color: '#36A2EB',
            },
            {
                name: t("not_Started"),
                data: stats[0]?.groupedStats?.map(cmd => cmd?.nonDemarrerCount) || [0],
                color: '#FFCE56',
            },
            {
                name: t("cancelled"),
                data: stats[0]?.groupedStats.map(cmd => cmd?.annulerCount) || [0],
                color: '#F44336',
            },
            {
                name: t("completed"),
                data: stats[0]?.groupedStats?.map(cmd => cmd?.terminerCount) || [0],
                color: '#60a656',
            },
        ],
    };

    const stackedBarOptions = {
        chart: {
            type: 'bar',
            stacked: true,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                horizontal: false,
            },
        },
        xaxis: {

            categories: stats[0]?.groupedStats?.map(item => `${item?.mois}/${item?.annee}`) || [t("no_data")],

        },
        yaxis: {
            title: {
                text: t("number_of_orders"),
            },
            labels: {
                formatter: (val) => val,
            },
        },
        title: {
            text: t("monthly_order_statistics"),
            align: 'center',
        },
        fill: {
            opacity: 1,
        },
    };



    return (
        <LayoutTransporter>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: '2rem',
                    paddingBottom: '4rem',
                }}
            >
                <GradientText
                    style={{
                        fontSize: isSmallScreen ? '2rem' : '2.5rem'
                    }}
                >{t("statistics").toUpperCase()}</GradientText>

            </div>
            {chargementEnCours ?
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'white',
                        marginTop: "10rem"
                    }}
                >
                    <div className='customLoader'></div>
                </div>
                :
                <>
                    <div
                        style={{
                            display: 'flex',
                            gridTemplateColumns: isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(4, 1fr)',
                            gap: '1rem',
                            marginBottom: '2rem',
                            width: '100%',
                            fontFamily: 'Montserrat',
                            paddingLeft: '2rem',
                            paddingRight: '2rem'
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: '#f0f0f0',
                                padding: '20px',
                                borderRadius: '10px',
                                textAlign: 'center',
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                            }}>
                            <h4>{t("revenue")}</h4>
                            <p>{caMensuel.reduce((sum, item) => sum + item.totalPrix, 0)} €</p>
                        </div>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            gridTemplateColumns: isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)',
                            gap: '1rem',
                            width: '100%',
                            fontFamily: 'Montserrat',
                            paddingLeft: '2rem',
                            paddingRight: '2rem',
                            marginBottom: '4rem',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: '#f0f0f0',
                                padding: '20px',
                                borderRadius: '10px',
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)'
                            }}
                        >
                            <Chart options={pieOptions} series={pieSeries} type="pie" height={350} />
                        </div>

                    </div>

                    <div
                        style={{
                            backgroundColor: '#f0f0f0',
                            padding: '20px',
                            borderRadius: '10px',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                            fontFamily: 'Montserrat',
                            marginBottom: '4rem',
                            marginLeft: '1rem',
                            marginRight: '1rem'
                        }}
                    >
                        <Chart options={barData.options} series={barData.series} type="bar" height={400} />

                    </div>
                    {stats &&
                        <div
                            style={{
                                backgroundColor: '#f0f0f0',
                                padding: '20px',
                                borderRadius: '10px',
                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                fontFamily: 'Montserrat',
                                marginBottom: '4rem',
                                marginLeft: '1rem',
                                marginRight: '1rem'
                            }}
                        >
                            <Chart
                                options={stackedBarOptions}
                                series={stackedBarData.series}
                                type="bar"
                                height={350}
                            />
                        </div>
                    }
                </>
            }
        </LayoutTransporter>
    );
}

export default TransporterStats;
